module.exports = __webpack_public_path__ + "09fd9f6027ca48a548850944813613dc.png";